define('controllers/book',['require','ractivejs','utils','olarkUtils','models','moment','rv!templates/booking/paymentplan','services/InvoiceCorrections','layout','services/bookingService','rv!templates/partials/nightlyRates','rv!templates/partials/chatWithUs','rv!templates/partials/messenger','rv!templates/vacationdetails','rv!templates/partials/hotelRating','rv!templates/partials/star','rv!templates/partials/halfStar'],function(require) {
    'use strict';
    var Ractive = require('ractivejs');
    var utils = require('utils');
    var olarkUtils = require('olarkUtils');
    var models = require('models');
    var moment = require('moment');
    var template = require('rv!templates/booking/paymentplan');
    var InvoiceCorrections = require('services/InvoiceCorrections');
    var layout = require('layout');
    var bookingService = require('services/bookingService');

    var bookController = {
        load: function (querystring) {
            var ractive;
            var ic = new InvoiceCorrections();
            var planningData = bookingService.deserializePlanning(querystring);
            var reviewElementId = '#paymentPlanView';
            var booking = planningData != null;
            bookingService.getBookingLogs('fe - bookController load() - booking', JSON.stringify(booking));
            if (booking &&
                (planningData.ManualBooking == null || 
                window.app.controllerManager.state.hoteladestinndetails && 
                window.app.controllerManager.state.hoteladestinndetails.cancellationPolicies !== undefined)) {
                this.setBreadCrumbs(planningData.DestinationInfo.DestinationSourceID,
                                    planningData.Provider,
                                    planningData.DestinationInfo.VRegion);

                if (planningData.DestinationInfo.VRegion.RegionID !== 0) {
                    document.title = 'Book {0}'.format(planningData.DestinationInfo.VRegion.RegionName);
                }

                if (planningData.ManualBooking != null) {
                    // Attach previous page cancellation policies for manual booking
                    var policies = window.app.controllerManager.state.hoteladestinndetails.cancellationPolicies;
                    var loyaltyPolicies = window.app.controllerManager.state.hoteladestinndetails.loyaltyCancellationPolicies;
                    if (policies !== null) {
                        planningData.DestinationInfo.Rate.CancellationPolicies = policies; 
                        planningData.DestinationInfo.Rate.CheckRateCancellationPolicies = loyaltyPolicies; 
                    }
                }
            } else {
                if ($('#paymentPlanView').length === 0) {
                    bookingService.getBookingLogs('fe - bookController load()', 'paymentPlanView had a length of 0, it should re-direct to Hotel New Search');
                    //means we hit the book page with no querystring, so take us back to destinations...
                    window.location.hash = '/hotel-new-search';
                } else {
                    bookingService.getBookingLogs('fe - bookController load()', 'The else was hit, it does nothing');
                }
            }

            /**
             * Runs after the review data request completes regardless of whether it errors or not.
             */
             function onFinally() {
                bookingService.getBookingLogs('fe - onFinally()', '');
                ractive.set('loading', false);
            }

            /**
             *  Highlights the cancellation policy that is currently in effect for each vacation
             * 
             */
             function cancellationHighlight(bookingData) {
                var policyIndex = null;
                var policyArray = [];
                for (var i = 0; i < bookingData.Vacations.length; i++) {
                    policyArray = bookingData.Vacations[i].PlanningData.DestinationInfo.Rate.CancellationPolicies;
                    // Expected in order
                    if (policyArray) {
                        for (var j = 0; j < policyArray.length; j++) {
                            if (moment.utc(policyArray[j].FromUTC).isBefore(moment.utc())) {
                                policyIndex = j;
                            }
                        }
                        if (policyIndex !== null) {
                            bookingData.Vacations[i].PlanningData.DestinationInfo.Rate.CancellationPolicies[policyIndex].Highlight = true;
                        }
                    }
                    policyIndex = null;
                    policyArray = [];
                }
                console.log(bookingData);
                return bookingData;
            }

            /**
             * Build out the nightly rates so we have correctly-rounded rates for bookings with pennies distributed between the nights so they add up to the total (unless they're already set up correctly).
             * @param {ReviewVacationPaymentPlan} bookingData 
             */
            function buildNights(bookingData) {
                bookingData.Vacations.forEach(function (vacation) {
                    var rate = vacation.PlanningData.DestinationInfo.Rate;
                    if (!ic.needsCorrections(rate.RoomRateTotal, rate.HotelFeeTotal, rate.HotelTaxFeeTotal, vacation.Nights)) {
                        return;
                    }
                    vacation.Nights = ic.generateCorrectionNights(rate.RoomRateTotal, rate.HotelFeeTotal, rate.HotelTaxFeeTotal, vacation.Nights)
                        .map(function(n) {
                            return {
                                Rate: n.RoomRate,
                                Fee: n.HotelFees,
                                Tax: n.HotelTaxFees,
                                ReservationDate: n.ReservationDate
                            };
                        });
                });
            }

            /**
             * get vacations where there is an overage and it has changed
             *      -currentvac will always be different 
             *      -existing vacations that begin before or on the same day should come out to be the same amount 
             *          -unless there's an nsf or change to schedule amount
             *          -unless we've already begun applying funds to a goal
             *          -if they did a onetime that has been processed, the overage might come out to be nothing anyway
             *      -existing vacaitions that occur after the vacation that's being booked could come out different
             * @param {ReviewVacationPaymentPlan} bookingData 
             * @returns {Array<DisplayVacation>} 
             */
             function getOverageVacations(bookingData) {
                return bookingData.Vacations.filter(function (v) {
                    return v.OverageOptions.Amounts.TotalNonTaxAndNonMatch > 0 ||
                           v.OverageOptions.Amounts.TaxPassThrough > 0;
                });
            }

            /**
             * Finds the vacation we're booking, if any. Otherwise returns the first vacation.
             * @param {ReviewVacationPaymentPlan} bookingData 
             * @returns {DisplayVacation} 
             */
             function getInitialVacation(bookingData) {
                if (bookingData.Vacations == null || bookingData.Vacations.length === 0) {
                    bookingService.getBookingLogs('fe - getInitialVacation()', 'initialVacation is null');
                    return null;
                }
                var initialVacation = bookingData.Vacations.filter(function(v) { return v.IsCurrentVacation; })[0];
                if (initialVacation == null) {
                    initialVacation = bookingData.Vacations[0]; //means we're simply viewing our vacations, so just select first one by default
                }
                bookingService.getBookingLogs('fe - getInitialVacation() // initialVacation', JSON.stringify(initialVacation));
                return initialVacation;
            }

            /**
             * Loads the ractive view with an object that will cause an error to be shown. 
             * Display exceptions can possibly be thrown during data access...
             * @param {object} err  
             */
            function onReviewPageError(err) {
                var message = utils.tryGetValue(err, 'responseJSON.Message') || 'An error occurred while loading the review page. Please reload and try again.';
                ractive.set('data.GlobalMessenger.Errors', [message]);
            }
            
            /**
             * Build out the overage onetime and goal options
             * Note there are 3 types of options
             *     -0 events: force onetime
             *     -1 event: onetime today or goal for next event date
             *     ->1 events: onetime today or goal of total/eventCount to my next eventCount scheduled contributions
             * @param {DisplayVacation} vacation 
             * @param {bool} forTax
             * @returns {Array} 
             */ 
             function getOverageOptions(vacation, forTax) {
                if (vacation == null) { return null; }
                var amountProp = forTax ? 'TaxPassThrough' : 'TotalNonTaxAndNonMatch';
                var amount = vacation.OverageOptions.Amounts[amountProp];
                if (amount === 0) {
                    return null;
                }
                var amountFormatted = utils.formatMoney(amount);
                var bankIdProp = forTax ? 'BankIdTax' : 'BankIdNonTax';
                var bankId = vacation.OverageOptions[bankIdProp];
                var forVacation = '';// multipleVacations ? ' for "{0}"'.format(vacation.PlanningData.VacationName) : '';
                var oneTimeOption = {
                    Description: 'Do a one time transfer of {0} today{1}.'.format(amountFormatted, forVacation),
                    ChooseAccount: true,
                    Selected: vacation.IsCurrentVacation ? false : bankId != null
                };
                var options = [oneTimeOption];
                if (vacation.AchCount !== 0) {
                    var goalOption = {
                        Description: vacation.AchCount === 1 ?
                            'Add {0} to my next scheduled contribution{1}.'.format(amountFormatted, forVacation) :
                            'Add {0} to my next {1} scheduled contributions{2}.'.format(utils.formatMoney(amount / vacation.AchCount, 2), vacation.AchCount, forVacation),
                        ChooseAccount: false,
                        Selected: vacation.IsCurrentVacation ? false : bankId == null
                    };
                    options.unshift(goalOption);
                }
                //set properties for selecting default account
                options.forEach(function(o) {
                    o.ForTax = forTax;
                    o.Vacation = vacation;
                });
                return options;
            }

            /**
             * Adds overage options for each vacation
             * @param {Array<DisplayVacation>} overageVacations  
             */
             function buildOverageOptions(overageVacations) {
                var overageOptions = {};
                overageVacations.forEach(function (vacation) {
                    overageOptions[vacation.DestinationId] = {
                        tax: getOverageOptions(vacation, true),
                        nonTax: getOverageOptions(vacation, false)
                    };
                });
                return overageOptions;
            }

            /**
             * Populates the ractive view with our book data.
             * Note that 'data' shall return to the server with the same shape so it can be deserialized.
             * TODO: when we improve handling of DBA (move to querystring, pass along if there in global.asax and thus remove timeout redirect nonsense), remove the check for an error property--this is needed for when we are booking as someone and then lose our session...
             * @param {ReviewVacationPaymentPlan} bookingData  
             */
             function onloadReviewPage(bookingData) {
                bookingService.getBookingLogs('fe - [start] onloadReviewPage()', JSON.stringify(bookingData));

                if (bookingData.error != null) {
                    ractive.set('data.GlobalMessenger.Errors', ['Your session has timed out.']);
                    return;
                }
                console.log(bookingData);
                var data = ractive.get();

                bookingService.getBookingLogs('fe - onloadReviewPage() // ractive.get()', JSON.stringify(data));

                // update all cancellation policies that exist
                bookingData = cancellationHighlight(bookingData);
                data.data = bookingData;
                data.activeVacation = getInitialVacation(bookingData);
                
                // No region hotel page title
                if (data.activeVacation != null && data.activeVacation.PlanningData.DestinationInfo.VRegion.RegionID === 0) {
                    document.title = 'Book {0}'.format(data.activeVacation.PlanningData.DestinationInfo.Location);
                }

                var overageVacations = getOverageVacations(bookingData);
                data.overageVacations = overageVacations;
                data.overageOptions = buildOverageOptions(overageVacations, data);
                data.hasTaxOverages = overageVacations.some(function (v) { return v.OverageOptions.Amounts.TaxPassThrough > 0; });
                data.hasNonTaxOverages = overageVacations.some(function (v) { return v.OverageOptions.Amounts.TotalNonTaxAndNonMatch > 0; });
                buildNights(bookingData);
                data.hasApprovedLink = bookingData.BankAccounts.some(function (b) { return b.Approved; });

                ractive.reset(data);
                bookingService.getBookingLogs('fe - [end] onloadReviewPage() // after ractive.reset(data)', JSON.stringify(ractive.get()));
            }

            /**
             * Loads the vacation payment plan data so we can see how booking this vacation would affect the member's current payment plan.
             * @param {bool} isBooking indicates whether we're simply reviewing our payment plan for our current future vacations or trying to book another vacation
             * @returns {Promise} 
             */
            function loadReviewData(url, data) {
                ractive.set('loading', true);
                bookController.loading = data == null ?
                    $.get(url) :
                    $.postJSON(url, data);
                return bookController.loading
                        .then(onloadReviewPage, onReviewPageError)
                        .always(onFinally);
            }

            /**
             * Validates all the vacations prior to booking
             * @param {object} plan
             * @returns {Array<string>} 
             */
             function validate(plan) {
                var errors = [];
                plan.data.Vacations.forEach(function (vacation) {
                    if (!vacation.AgreedToPolicies) {
                        errors.push('You must agree to the hotel policies to book this reservation.');
                    }

                    if (vacation.HasHotelExcludedTax && !vacation.AgreedToFees) {
                        errors.push('You must agree to the additional hotel charges to book this reservation.');
                    }

                    var overageOpts = plan.overageOptions[vacation.DestinationId];
                    if (overageOpts != null) {
                        var vacName = vacation.PlanningData.VacationName;
                        if (overageOpts.tax != null && !overageOpts.tax.some(function (o) { return o.Selected; })) {
                            errors.push('Please indicate how you\'d like to fund your taxes for {0}.'.format(vacName));
                        }
                        if (overageOpts.nonTax != null && !overageOpts.nonTax.some(function (o) { return o.Selected; })) {
                            errors.push('Please indicate how you\'d like to fund contribution shortage for {0}.'.format(vacName));
                        }
                    }
                });
                return errors;
            }

            /**
             * The api for booking and recalculating payment plan is very similar, so centralize the logic here
             * @param {string} loadVar
             * @param {string} endpoint 
             * @param {function} onSuccess 
             */
             function applyPlan(loadVar, endpoint, onSuccess) {
                var plan = ractive.get();
                bookingService.getBookingLogs('fe - applyPlan() - plan', JSON.stringify(plan));

                var errors = validate(plan);
                ractive.set('data.GlobalMessenger.Errors', errors);
                if (errors.length === 0) {
                    // booking variable is set to true
                    bookingService.getBookingLogs('fe - applyPlan()', 'booking is set to true');
                    ractive.set(loadVar, true);
                    bookingService.getBookingLogs('fe - applyPlan()', 'calling BookingController Book');
                    $.postJSON(endpoint, plan.data)
                        .then(
                            onSuccess.bind(ractive),
                            function (err) {
                                ractive.set('data.GlobalMessenger.Errors', window.Utilities.getFriendlyErrors(err));
                            }
                        )
                        .always(function() {
                            bookingService.getBookingLogs('fe - applyPlan()', 'booking is set to false, loadingReview is set to false');

                            ractive.set(loadVar, false);
                            ractive.set('loadingReview', false);
                        });
                } else {
                    // this could be where missing confirmation page is happening
                    bookingService.getBookingLogs('fe - applyPlan()', 'errors.length > 0');
                    bookingService.getBookingLogs('fe - applyPlan()', JSON.stringify(errors)); // This is not printing out
                }
            }

            /**
             * After booking, we load in the vacation details to show a confirmation view
             * TODO: when we rewrite the vacations page, update this too to use an api endpoint that returns json with no html and stuff...
             * @param {ReviewBooking} booking 
             * @returns {Promise} 
             */
            function getVacDetails(booking) {
                bookingService.getBookingLogs('fe - applyPlan // getVacDetails', JSON.stringify(booking));
                ractive.set('loadingReview', true);
                return $.post('/myaccount/vacations/vacationajax.aspx', {
                    method: 'getSingle',
                    VacationID: booking.VacationId
                });
            }

            /**
             * Sets up all our ractive methods/handlers and sets the loading to true while we wait for data to be populated
             */
            function initRactiveView() {
                var data = {
                    loading: false,
                    provider: models.provider,
                    moment: moment,
                    StaticContentUrl: window.ServerData.StaticContentUrl,
                    LinkAccountUrl: '/MyAccount/FinancialAccount.aspx?r={0}'.format(encodeURIComponent(window.location)),

                    getDetailLink: function(hotelId, provider, region) {
                        return bookingService.getDetailLink(hotelId, provider, region);
                    },

                    /*Calculated data--todo: if performance becomes an issue, consider wrapping vacations in objects that contain these calculated properties and set them upon load. Still send data.Vacations since the object refs will remain.*/
                    /**
                     * Get the policies that the user must agree to prior to booking
                     * @param {DisplayVacation} vacation 
                     * @returns {String} 
                     */
                    getPolicy: function(vacation) {
                        if (vacation == null) {
                            return '';
                        }
                        var policies = '';
                        if (vacation.PlanningData.Provider === models.provider.Adestinn) {
                            var rateRules = utils.tryGetValue(vacation, 'GWSTransaction.rateRules');
                            if (rateRules != null) {
                                policies = '{0}<br/>{1}'.format(rateRules.cancellation, rateRules.checkinInfo)
                                    .toLowerCase()
                                    .replace('cxl', 'cancel')
                                    .replace('prgm', 'program')
                                    .toTitleCase();
                            } else {
                                var manualPolicies = utils.tryGetValue(vacation, 'PlanningData.ManualBooking.CancellationPolicy');
                                if (manualPolicies != null) {
                                    policies = manualPolicies;
                                } 
                            }
                        } else if (vacation.PlanningData.Provider === models.provider.Hotelbeds) {
                            var cancellation = vacation.PlanningData.DestinationInfo.Rate.CancellationPolicies;
                            if (cancellation && cancellation.length > 0) {
                                policies += '<br><span>Cancellation:</span><ul>';
                                cancellation.forEach(function(x) {
                                    policies += '<li>If cancelled on or after: ' + moment.utc(x.FromUTC).utcOffset(x.OffsetUTC).format('MM/DD/YYYY hh:mm A') + ' $' + x.Amount + '</li>';
                                }.bind(this));
                                policies += '</ul>';
                            } else {
                                // No Cancellation Policies from Hotelbeds.. Vacation cannot be cancelled/changed
                                policies += '<br><span>Cancellation:</span><ul>';
                                policies += '<li>Non-refundable vacations cannot be canceled at any time and must be fully funded.</li></ul>';
                            }

                            var promotions = vacation.PlanningData.DestinationInfo.Rate.Promotions;
                            if (promotions && promotions.length > 0) {
                                policies += '<br><span>Promotions:</span><ul>';
                                promotions.forEach(function(x) {
                                    policies += '<li>* ' + x.Name + '</li>';
                                }.bind(this));
                                policies += '</ul>';
                            }

                            var offers = vacation.PlanningData.DestinationInfo.Rate.Offers;
                            if (offers && offers.length > 0) {
                                policies += '<br><span>Offers:</span><ul>';
                                offers.forEach(function(x) {
                                    policies += '<li>* ' + x.Name + ': ' + x.Amount + '</li>';
                                }.bind(this));
                                policies += '</ul>';
                            }
                        }

                        return policies.replace('\n', '<br/>');
                    },

                    /**
                     * Get friendly string that describes the travelers of this vacation
                     * e.g. 2 Adults, 1 Child
                     * @param {DisplayVacation} vacation 
                     * @returns {String} 
                     */
                    getTravelers: function(vacation) {
                        if (vacation == null) {
                            return '';
                        }
                        var adultString = vacation.PlanningData.TravelerInfo.AdultCount === 0 ? '' : '{0} {1}'.format(vacation.PlanningData.TravelerInfo.AdultCount, vacation.PlanningData.TravelerInfo.AdultCount > 1 ? 'Adults' : 'Adult');
                        var childString = vacation.PlanningData.TravelerInfo.ChildCount === 0 ? '' : ', {0} {1}'.format(vacation.PlanningData.TravelerInfo.ChildCount, vacation.PlanningData.TravelerInfo.ChildCount > 1 ? 'Children' : 'Child');
                        return adultString + childString;
                    },

                    /**
                     * Get friendly string that shows children ages 
                     * e.g. Children Ages: 1,3
                     * @param {DisplayVacation} vacation 
                     * @returns {String} 
                     */
                    getTravelerAges: function(vacation) {
                        if (vacation == null) {
                            return '';
                        }
                        var childAgeString = '';
                        var ages = vacation.PlanningData.TravelerInfo.ChildAges;
                        if (ages.length > 0) {
                            childAgeString += ages.length === 1 ? 'Child Age: ': 'Children Ages: ';
                            for (var i = 0; i < ages.length; i++) {
                                childAgeString += ages[i];
                                if (i !== ages.length - 1) {
                                    childAgeString += ', ';
                                }
                            }
                        }
                        return childAgeString;
                    },


                    /**
                     * Get friendly, readable Arrive/Depart text
                     * @param {DisplayVacation} vacation 
                     * @returns {String} 
                     */
                    getFromTo: function(vacation) {
                        if (vacation == null) {
                            return '';
                        }
                        return '{0} to {1}'.format(moment(vacation.PlanningData.Timeline.FromDate).format('MM/DD/YYYY'), moment(vacation.PlanningData.Timeline.ToDate).format('MM/DD/YYYY'));
                    },

                    /**
                     * Gets friendly roomname
                     * @param {DisplayVacation} vacation 
                     * @returns {String} 
                     */
                    getRoomName: function(vacation) {
                        if (vacation == null) {
                            return '';
                        }
                        return vacation.PlanningData.DestinationInfo.RoomName.toTitleCase();
                    },

                    /**
                     * Gets friendly room
                     * @param {DisplayVacation} vacation 
                     * @returns {String} 
                     */
                    getRoomDescription : function(vacation) {
                        if (vacation == null) {
                            return '';
                        }
                        return vacation.PlanningData.DestinationInfo.RoomDescription.toTitleCase();
                    },

                    /**
                     * Gets friendly hotel description
                     * @param {DisplayVacation} vacation
                     * @returns {String}
                     */
                    getHotelDescription: function (vacation) {
                        if (vacation == null || vacation.PlanningData.DestinationInfo.HotelDescription == null) {
                            return '';
                        }

                        var description = vacation.PlanningData.DestinationInfo.HotelDescription;
                        if (description.length > 255) {
                            description = description.substring(0, 255) + '...';
                        }
                        return description;
                    },

                    //TODO: test on Test server
                    agreeToFees: function () {
                        //if previously false, update AgreedToFees to true
                        if (!this.ractive.get('AgreedToFees')) {
                            $('#chkAgreedToFees').prop('checked', true);
                            this.ractive.set('AgreedToFees', true);
                            $.fancybox.close();
                        }
                    },

                    showAgreeToFeesModal: function () {
                        if (!this.ractive.get('AgreedToFees')) {
                            $('#chkAgreedToFees').prop('checked', false);
                            $.fancybox({
                                'href': '#agree-to-fees-modal'
                            });
                        }
                    },

                    /**
                     * Retrieve any overage options for the given vacation
                     * @param {DisplayVacation} vacation 
                     * @param {bool} forTax 
                     * @returns {Array<string>} 
                     */
                    getOverageOptionsByVac: function(vacation, prop) {
                        return utils.tryGetValue(ractive.get(), ['overageOptions', vacation.DestinationId, prop]);
                    }
                };

                var partials = {
                    nightlyRates: require('rv!templates/partials/nightlyRates'),
                    chatWithUs: require('rv!templates/partials/chatWithUs'),
                    messenger: require('rv!templates/partials/messenger'),
                    vacationDetails: require('rv!templates/vacationdetails'),
                    hotelRating: require('rv!templates/partials/hotelRating'),
                    star: require('rv!templates/partials/star'),
                    halfStar: require('rv!templates/partials/halfStar'),
                };

                bookingService.getBookingLogs('fe - initRactiveView() // booking?', booking ? 'yes' : 'no');
                bookingService.getBookingLogs('fe - initRactiveView() // data', JSON.stringify(data));

                bookController.ractive = booking ? layout.initRactive(data, template, {
                    partials: partials
                }) : new Ractive({
                    el: reviewElementId,
                    template: template,
                    partials: partials,
                    data: data,
                    // Only for vacationDetails page
                });

                bookController.ractive.on({
                    /**
                     * Switch the active vacation to the one the user clicked
                     * @param {Ractive Event} e 
                     */
                    onVacationClick: function (e) {
                        this.set('error', '');
                        this.set('activeVacation', e.context);
                    },

                    /**
                     * Return the the current vacation view, so we can get on with booking
                     * @param {Ractive Event} e 
                     */
                    onBackToCurrentVacation: function (e) {
                        bookingService.getBookingLogs('fe - onBackToCurrentVacation()', '');
                        this.set('error', '');
                        this.set('activeVacation', getInitialVacation(ractive.get().data));
                    },

                    openChat: olarkUtils.openChat,

                    /**
                     * When an overage option is selected, set the option as selected, show bank accounts if the option allows it and select the first one on the list.
                     * @param {bool} forTax
                     * @param {Array} bankAccounts
                     */
                    onOverageSelect: function (e) {
                        var accountProp = e.context.ForTax ? 'BankIdTax' : 'BankIdNonTax';
                        var vacation = e.context.Vacation;
                        var bankAccounts = ractive.get('data.BankAccounts');
                        vacation.OverageOptions[accountProp] = e.context.ChooseAccount && bankAccounts.length > 0 ? bankAccounts[0].Id : null; //TODO: determine how this actually works--ractive somehow knows this has changed, even in IE8
                    },

                    /**
                     * Upon booking, send our current vacation to the server with the chosen overage options and agreement to policies
                     * Note that if the server finds an issue, it might send back a recalculated plan instead of the confirmation number. In that case, we must present the user with the recalculated plan.
                     * Note we track with google once we know booking has succeeded
                     * @param {Ractive Event} e 
                     */
                    onBook: function(e) {
                        bookingService.getBookingLogs('fe - onBook // Book Now button was pressed', '');

                        var confirmBooking = false;                   
                        var bookingData = ractive.get().data;

                        bookingService.getBookingLogs('fe - onBook() // bookingData (ractive.get().data)', JSON.stringify(bookingData));

                        var vacation = bookingData.Vacations.find(function(v) {
                            return v.IsCurrentVacation === true;
                        });

                        $.get('/api/booking/duplicatebookingcount/?userId={0}&destSourceId={1}&destTypeId={2}&startDate={3}&endDate={4}'.format(bookingData.UserId, vacation.PlanningData.DestinationInfo.DestinationSourceID, vacation.PlanningData.DestinationInfo.DestinationTypeID, vacation.PlanningData.Timeline.FromDate, vacation.PlanningData.Timeline.ToDate)).then(function(count) {
                            confirmBooking = count === 0;

                            if (count > 0) {
                                confirmBooking = confirm('Are you sure you want to book this vacation? It looks like this vacation already exists for your account.');
                            } 

                            if (confirmBooking) {
                                applyPlan('booking', '/api/booking/book', function(bookingResponse) {
                                    bookingService.getBookingLogs('fe - onBook () -> applyPlan // bookingResponse', JSON.stringify(bookingResponse));

                                    if (bookingResponse.VacationID === null) {  
                                        bookingService.getBookingLogs('fe - onBook () -> applyPlan // bookingResponse.VacationID was null.. Allow the user to try again', '');
                                        layout.loadServerData();
                                        bookingResponse.IsValid = true; //allow the user to try again
                                        onloadReviewPage(bookingResponse);
                                        return;
                                    }
                                    window.gaTrack('conversions', 'Booked', bookingResponse, this.get('activeVacation').TotalCost);
                                    return $.when(
                                        getVacDetails(bookingResponse),
                                        layout.loadServerData(),
                                        bookingService.getBookingLogs('fe - onBook () $.when -> .then', 'Now should load confirmation page')
                                    ).then(function(vacDetails) {
                                        bookingService.getBookingLogs('fe - onBook () -> applyPlan // vacDetails', JSON.stringify(vacDetails));
                                        bookingService.getBookingLogs('fe - onBook () -> applyPlan // vacDetails[0]', JSON.stringify(vacDetails[0]));

                                        ractive.set('data', JSON.parse(vacDetails[0]));

                                        bookingService.getBookingLogs('fe - confirmBooking() // ractive.get()', JSON.stringify(ractive.get()));

                                        bookingService.getBookingLogs('fe - setting showSuccess', '');
                                        ractive.set('showSuccess', true);
                                        bookingService.getBookingLogs('fe - showSuccess has been set', JSON.stringify(ractive.get('showSuccess')));
                                    }).catch(function(error) {
                                        bookingService.getBookingLogs('fe - onBook () -> catch() // Error', error);
                                    });
                                });
                            }
                        }.bind(this));
                    },

                    /**
                     * When reviewing the payment plan, the user can recalculate their payment plan.
                     * Note that the returned plan may have errors indicating that nothing was saved server-side.
                     * @param {RactiveEvent} e 
                     */
                    onApplyPlan: function(e) {
                        applyPlan('applying', '/api/booking/applyplan', function(plan) {
                            ractive.set('data', plan);
                            ractive.push('data.GlobalMessenger.InfoMessages', 'Payment plan updated successfully!');
                        });
                    }
                });
                ractive = bookController.ractive;
                return ractive;
            }
            
            initRactiveView();

            /**
             * Handy way to verify the ractive view is rending various scenarios correctly...probably cleaner/more-modern way to do this, but this is perfect for now.
             * Consider passing TestControllers dynamically if in dev or has querystring or something and make all the test controllers cooperate with each other.
             * Take a look at autoamted FE testing/virtual browsers to at least have an idea of how it works
             */
            var testing = {
                _test: function (jsonFile) {
                    return function () {
                        var url = /^\//.test(jsonFile) ? jsonFile : '/fe/jstests/data/booking/{0}.json?v={1}'.format(jsonFile, Math.random());
                        loadReviewData(url);
                    };
                },
                ractive: ractive
            };
            testing.tests = {
                bookingOne: testing._test('bookingOne'),
                bookingMultiple: testing._test('bookingMultiple'),
                reviewingOne: testing._test('reviewingOne'),
                reviewingMultiple: testing._test('reviewingMultiple'),
                bookingerrors: testing._test('bookingerrors'), // jshint ignore:line
                foReal: testing._test('/api/booking/GetPaymentPlan/?IncludeCurrent=true&testing=yep')
            };
            window.bookTests = testing;

            //init. assume we're reviewing if no bookingData...
            loadReviewData('/api/booking/GetPaymentPlan/', planningData);
        },

        /**
         * if we're on the booking page, we need to set up breadcrumbs
         * @param {int} hotelId  
         */
        setBreadCrumbs: function(hotelId, provider, region) {
            layout.setBreadCrumbs([
                {
                    name: 'Search',
                    url: '/#/hotel-new-search'
                },
                {
                    name: 'Hotel Details',
                    url: bookingService.getDetailLink(hotelId, provider, {value: region.RegionName, id: region.RegionID})
                },
                {
                    name: 'Vacation Review'
                }
            ]);
        },

        unload: function() {
            if (bookController.ractive != null) {bookController.ractive.teardown();}
        }
    };
    return bookController;
});

